// src/services/serviceService.js
import api from './api';

// Helper to ensure array response (supports multiple backend shapes)
const ensureArray = (res) => {
  const data = res?.data;

  if (Array.isArray(data)) return data;

  // common wrappers
  if (data && Array.isArray(data.services)) return data.services;
  if (data && Array.isArray(data.data)) return data.data;
  if (data && Array.isArray(data.results)) return data.results;

  return [];
};

export const serviceService = {
  // ✅ PUBLIC (Published only)
  getAllPublic: async () => {
    const res = await api.get('/services');
    return ensureArray(res);
  },

  // ✅ ADMIN (All services)
  // Backend route must exist: GET /api/services/admin
  getAllAdmin: async () => {
    const res = await api.get('/services/admin');
    return ensureArray(res);
  },

 // ✅ PUBLIC: service detail by slug
getBySlug: async (slug) => {
  const safeSlug = encodeURIComponent(slug);
  const res = await api.get(`/services/slug/${safeSlug}`);
  return res.data;
},


  // ✅ ADMIN: service by id
  // Your backend route usually: GET /api/services/id/:id
  getById: async (id) => {
    const res = await api.get(`/services/id/${id}`);
    return res.data;
  },

  // ✅ ADMIN CRUD
  create: async (data) => {
    const res = await api.post('/services', data);
    return res.data;
  },

  update: async (id, data) => {
    const res = await api.put(`/services/${id}`, data);
    return res.data;
  },

  delete: async (id) => {
    const res = await api.delete(`/services/${id}`);
    return res.data;
  },
};
